// extracted by mini-css-extract-plugin
export default {"root":"Paper_root__jeRIq","top":"Paper_top__NHRHP"};